module.exports = __webpack_public_path__ + "static/media/shortTextphone.fb73aef4.svg";